<template>
  <div
    class="tw-bg-white tw-text-primary-grey-800 tw-w-full tw-flex tw-items-center tw-p-4 tw-gap-4 tw-flex-col"
    :class="className"
  >
    <slot name="image">
      <div>
        <svg
          width="216"
          height="162"
          viewBox="0 0 216 162"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M199.279 125.167C201.047 122.903 202 120.496 202 118C202 104.745 175.137 94 142 94C111.689 94 86.6271 102.991 82.5733 114.669C35.1959 117.21 0 126.691 0 138C0 151.255 48.3532 162 108 162C167.647 162 216 151.255 216 138C216 133.28 209.869 128.878 199.279 125.167Z"
            fill="#E7E8E9"
          />
          <path d="M38 58H128.219L128 138H38V58Z" fill="#DBF0EB" />
          <path d="M128.219 58H178V138H128L128.219 58Z" fill="#BBE2DA" />
          <path d="M38 58L24 28H82.0803L97 58H38Z" fill="#2F6F61" />
          <path d="M178 58L192.219 28H142.219L128.219 58H178Z" fill="#DBF0EB" />
          <path d="M73 58H97V86H73V58Z" fill="#53B7A1" />
          <path
            d="M131.646 12.8192C131.963 12.3667 131.853 11.7432 131.4 11.4264C130.948 11.1096 130.325 11.2196 130.008 11.672L119.683 26.4167C119.367 26.8691 119.477 27.4927 119.929 27.8095C120.381 28.1262 121.005 28.0163 121.322 27.5639L131.646 12.8192Z"
            fill="#97D3C6"
          />
          <path
            d="M88.5735 12.8191C88.2567 12.3667 88.3667 11.7431 88.8191 11.4264C89.2715 11.1096 89.895 11.2195 90.2118 11.6719L100.536 26.4167C100.853 26.8691 100.743 27.4926 100.291 27.8094C99.8382 28.1262 99.2147 28.0162 98.8979 27.5638L88.5735 12.8191Z"
            fill="#97D3C6"
          />
          <path
            d="M109.11 1C109.11 0.447715 109.558 0 110.11 0C110.662 0 111.11 0.447715 111.11 1V27C111.11 27.5523 110.662 28 110.11 28C109.558 28 109.11 27.5523 109.11 27V1Z"
            fill="#97D3C6"
          />
        </svg>
      </div>
    </slot>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-text-center">
      <div class="tw-font-medium tw-text-xl">
        <slot name="title" />
      </div>
      <div class="tw-text-sm">
        <slot name="description" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from "vue";

const props = defineProps<{
  className?: Record<string, boolean> | string[] | string;
}>();

const { className } = toRefs(props);
</script>
